import React, { useContext, useState } from 'react'
import HeaderCrazy from '@/components/headers/HeaderCrazy'
import NavigationTokens from '@/components/navigation/NavigationTokens'
import NavigationSubmenus from '@/components/navigation/NavigationSubmenus'
import { slide as Menu, slide as Menu2 } from 'react-burger-menu'
import Chat from '@/components/chat/Chat'
import Link from 'next/link'
import { BiLogoTelegram } from 'react-icons/bi'
import { BsTwitterX } from 'react-icons/bs'
import { Context } from '@/components/Context'
import Box from '@/components/boxes/Box'
import { uni1d800 } from '@/utils/extras'

const handleClick = (hash: string) => {
    window.location.hash = hash
}

const ChatIcon = ({ hasNewMessage }) => (
    <svg
        viewBox="1 -3 25 30"
        width="35"
        height="32"
        className="border large"
        style={{
            marginLeft: '1px',
            cursor: 'pointer',
        }}
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Growing background icon */}
        <g
            style={{
                fill: 'none',
                stroke: 'var(--clr-gray)',
                strokeLinejoin: 'round',
                strokeLinecap: 'round',
                strokeDasharray: 'none',
                animation: hasNewMessage
                    ? 'colorChange 7s linear infinite, scaleUpFade 4s ease-in-out infinite'
                    : 'none',
                transformOrigin: 'center',
            }}
        >
            <path d="M 10.003979 1.9179932 C 9.3299795 1.9179932 8.7090059 2.310998 8.3810059 2.947998 L 4.7799805 9.9470215 C 4.4679805 10.550021 4.4679805 11.285987 4.7799805 11.886987 L 7.2749023 16.737598 L 4.4360352 23.891968 L 17.541479 19.855078 C 17.571643 19.846882 17.601183 19.837328 17.630835 19.827539 L 17.794971 19.777002 L 17.779077 19.772095 C 18.167959 19.603767 18.500316 19.297173 18.711011 18.887988 L 22.312036 11.886987 C 22.624036 11.285987 22.624036 10.550021 22.312036 9.9470215 L 18.711011 2.947998 C 18.383011 2.310998 17.761964 1.9179932 17.087964 1.9179932 L 10.003979 1.9179932 z " />
        </g>

        {/* Shrinking foreground icon */}
        <g
            style={{
                fill: 'var(--clr-gray)',
                scale: 1.1,
                animation: hasNewMessage ? 'pulsate 4s ease-in-out infinite' : 'none',
                transformOrigin: 'center',
            }}
        >
            <path
                d="M 10.003979 1.9179932 C 9.3299795 1.9179932 8.7090059 2.310998 8.3810059 2.947998 L 4.7799805 9.9470215 C 4.4679805 10.550021 4.4679805 11.285987 4.7799805 11.886987 L 7.2749023 16.737598 L 4.4360352 23.891968 L 17.541479 19.855078 C 17.571643 19.846882 17.601183 19.837328 17.630835 19.827539 L 17.794971 19.777002 L 17.779077 19.772095 C 18.167959 19.603767 18.500316 19.297173 18.711011 18.887988 L 22.312036 11.886987 C 22.624036 11.285987 22.624036 10.550021 22.312036 9.9470215 L 18.711011 2.947998 C 18.383011 2.310998 17.761964 1.9179932 17.087964 1.9179932 L 10.003979 1.9179932 z "
                // transform="matrix(0, 1, -1, 0, 0, 0)"
                style={{ transformOrigin: '13.4px 10.35px' }}
            />
            <g
                style={{
                    fill: 'black',
                    transformOrigin: 'center',
                }}
            >
                <circle cx="8.9750013" cy="10.949998" id="ellipse1" r="1.5" />
                <circle cx="13.525002" cy="10.949998" id="ellipse2" r="1.5" />
                <circle cx="18.074986" cy="11.024999" id="ellipse3" r="1.5" />
            </g>
        </g>
    </svg>
)

const Navigation = () => {
    const [showAllSubmenus, setShowAllSubmenus] = useState(true)
    const [leftOpen, setLeftOpen] = useState(false)
    const { pulsePrice, crazyPrice } = useContext(Context)

    return (
        <React.Fragment>
            <div className="menu-wrapper-row">
                <div className="menu-left">
                    <Menu2
                        className={'configuration-wrapper ' + leftOpen ? 'z-index-thousand' : 'z-index-hundred'}
                        pageWrapId={'page-wrap-chat'}
                        customBurgerIcon={<ChatIcon hasNewMessage={true} />}
                        onStateChange={(state) => setLeftOpen(state.isOpen)}
                    >
                        <Chat />
                    </Menu2>
                    <Link
                        href="https://t.me/CRAZY_414/"
                        className={'z-index-hundred'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <BiLogoTelegram className="social-media-icon margin-top-five gray border large-icon" />
                        &nbsp;
                    </Link>
                    <Link
                        href="https://www.x.com/yourtokenart"
                        className={'z-index-hundred'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <BsTwitterX className="social-media-icon margin-top-five gray border large-icon z-index-hundred" />
                    </Link>
                    <div className={'z-index-hundred'} onClick={() => handleClick('#dex')}>
                        <Box
                            caption={'  \uD836\uDE17CRAZY\u200C\uD836\uDE17'}
                            styleCaption={uni1d800.className + ' gray small'}
                            styleText={'small white'}
                            text={'$' + (crazyPrice ?? ' - ')}
                            textValue={crazyPrice}
                        />
                    </div>
                </div>
                <div className={leftOpen ? 'menu-right z-index-zero' : 'menu-right z-index-hundred'}>
                    <Link
                        href="https://dexscreener.com/pulsechain/0xe56043671df55de5cdf8459710433c10324de0ae"
                        className={'z-index-hundred'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Box
                            caption={'PLS'}
                            styleCaption={'small gray'}
                            styleText={'small white'}
                            text={'$' + (pulsePrice ?? ' - ')}
                            textValue={pulsePrice}
                        />
                    </Link>
                    <Menu
                        right
                        className={'configuration-wrapper'}
                        pageWrapId={'page-wrap-settings'}
                        outerContainerId={'outer-container'}
                        onStateChange={() => undefined}
                    >
                        <NavigationSubmenus showAllSubmenus={showAllSubmenus} setShowAllSubmenus={setShowAllSubmenus} />
                    </Menu>
                </div>
            </div>
            <div className="header-crazy-wrapper">
                <HeaderCrazy />
            </div>
            <NavigationTokens />
        </React.Fragment>
    )
}

export default Navigation
